module.exports = __webpack_public_path__ + "img/index_quick2.d789b433.jpg";